module.exports = __webpack_public_path__ + "06accfbde024e7b5cdf6891bfad109ff.pdf";